"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typographyMixin = exports.TYPOGRAPHY_DEFAULT_PROPS = void 0;
var _styledComponents = require("styled-components");
var _fontColorMixin = require("./fontColorMixin");
var _fontFamilyMixin = require("./fontFamilyMixin");
var _fontTypeIconAlignmentMixin = require("./fontTypeIconAlignmentMixin");
var _fontTypeMediaQueryMixin = require("./fontTypeMediaQueryMixin");
var _fontTypeMixin = require("./fontTypeMixin");
var _semanticElementMixin = require("./semanticElementMixin");
var TYPOGRAPHY_DEFAULT_PROPS = {
  fontColor: 'textDark',
  fontFamily: 'sansSerif'
};

/** @mixin typographyMixin */
/**
 * Adds all typography related mixins to your component.
 *
 * @example
 * import { typographyMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *    ${typographyMixin}
 * `';
 *
 * <Component
 *     fontType="h1"
 *     fontColor="brand"
 *     fontFamily="serif"
 * >
 *     Typography mixin example
 * </Component>
 *
 * @method
 * @param {object} props
 * @param {string} [props.fontType]
 * @param {string} [props.fontColor]
 * @param {string} [props.fontFamily]
 * @return {Interpolation}
 */
exports.TYPOGRAPHY_DEFAULT_PROPS = TYPOGRAPHY_DEFAULT_PROPS;
var typographyMixin = function typographyMixin(props) {
  var forwardedProps = Object.assign({}, TYPOGRAPHY_DEFAULT_PROPS, props);
  return [(0, _fontColorMixin.fontColorMixin)(forwardedProps), (0, _styledComponents.css)(["-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-transform:none;"]), (0, _fontFamilyMixin.fontFamilyMixin)(forwardedProps), (0, _fontTypeMixin.fontTypeMixin)(forwardedProps), (0, _fontTypeIconAlignmentMixin.fontTypeIconAlignmentMixin)(forwardedProps), (0, _fontTypeMediaQueryMixin.fontTypeMediaQueryMixin)(forwardedProps), (0, _semanticElementMixin.semanticElementMixin)(forwardedProps)];
};
exports.typographyMixin = typographyMixin;